module.exports = __webpack_public_path__ + "static/media/menuSpeech.4c2dbaf5.svg";